// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__XSeUL","wrapper":"styles_wrapper__kiNmk","header":"styles_header__1X25t","close":"styles_close__tH2x5","body":"styles_body__3l8Je","footer":"styles_footer__Exp02"};